import React from 'react';
import LazyLoad from 'react-lazyload';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';

// We're going to have a lot of seasonal variants of this gifting banner
// so we can just compose the variants using this one as a base

const GiftingBlockBase = ({ title, subtext, imgSrc, ctaText, ctaLink }) => {
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <LazyLoad>
          <img src={imgSrc} alt="giftcard" className={styles.image} />
        </LazyLoad>
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subText}>{subtext}</div>
        <a href={ctaLink} className={styles.ctaLink} data-test-id="gift-pro">
          {ctaText}
        </a>
      </div>
    </div>
  );
};

GiftingBlockBase.propTypes = {
  title: string.isRequired,
  subtext: string.isRequired,
  imgSrc: string.isRequired,
  ctaText: string.isRequired,
  ctaLink: string.isRequired
};

export default GiftingBlockBase;
